module.exports = __webpack_public_path__ + "img/arrow-left-long-solid.7ef36a9d.svg";